import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { GetUserResponseData } from "../types/user"

const getData = async (uuid: string | undefined) => {
  const { data } = await api.get(`/users/${uuid}`)
  return data
}

export const useUserDetail = (uuid: string | undefined):
  QueryObserverBaseResult<GetUserResponseData> => {
  const { data, ...props } = useQuery<GetUserResponseData>(
    queryKeys.USER(uuid),
    () => getData(uuid),
    { enabled: Boolean(uuid) }
  )
  return { data, ...props }
}
